import { render } from "./SubsidiariesGrid.vue?vue&type=template&id=009cd9fe&scoped=true"
import script from "./SubsidiariesGrid.vue?vue&type=script&lang=js"
export * from "./SubsidiariesGrid.vue?vue&type=script&lang=js"

import "./SubsidiariesGrid.vue?vue&type=style&index=0&id=009cd9fe&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009cd9fe"]])

export default __exports__